import moment from 'moment'
import {
  DatePicker,
  DatePickerProps,
  Form,
  Label,
  Space,
} from 'components/common'

export interface DatePeriodPickerProps extends DatePickerProps {}

export const DatePeriodPicker = ({
  ...props
}: DatePeriodPickerProps): JSX.Element => (
  <Space size="large" direction="horizontal">
    <div>
      <Label>開始日</Label>
      <Form.Item
        name="startDate"
        validateTrigger="onChange"
        rules={[{ required: true, message: '開始日の入力は必須です' }]}
      >
        <DatePicker
          {...props}
          disabledDate={(current) => {
            return current && current < moment().subtract(1, 'days')
          }}
        />
      </Form.Item>
    </div>
    <div>
      <Label>終了日</Label>
      <Form.Item
        name="endDate"
        validateTrigger="onChange"
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value: moment.Moment) {
              if (!value || value.isSameOrAfter(getFieldValue('startDate'))) {
                return Promise.resolve()
              }
              return Promise.reject(
                new Error('開始日より前の日付は設定できません')
              )
            },
          }),
          {
            required: true,
            message: '終了日の入力は必須です',
          },
        ]}
      >
        <DatePicker
          {...props}
          disabledDate={(current) => {
            return current && current < moment().subtract(1, 'days')
          }}
        />
      </Form.Item>
    </div>
  </Space>
)
